var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.modal)?_c(_vm.modal.component,_vm._b({tag:"component",class:{ 'd-block': _vm.modal.component }},'component',_vm.modal.props,false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }